export interface FundingRound {
  id: string;
  roundName: string;
  year: number;
  headlineInvestors?: string[];
}

// TODO(content/legal): a funding round asserts a real transaction with real
// named third-party investors who could deny it — the same class of claim
// pressMentions.ts and leadership.ts already declined to fabricate, and
// sharper than this page's existing self-descriptive TRACTION stats (a
// founding year is a low-stakes single fact; a funding round is a specific,
// checkable financial claim). The ticket's own AC gates this content behind
// "board/founder-approved" disclosure, which itself is an acknowledgment
// that publishing requires an approval mechanism this static SPA doesn't
// have. Even a qualitative descriptor ("self-funded", "pre-seed") was
// considered and rejected for the same reason legalRegistrations.ts ships
// null rather than "registration in progress" — it's still an assertion
// about ZenFresh's real financial state with no ground truth here.
// FundingHistorySection.tsx hides this sub-section entirely while empty.
export const FUNDING_ROUNDS: FundingRound[] = [];

export interface GrowthMetrics {
  cities: string;
  gmvGrowth?: string;
  customerGrowth?: string;
}

// `cities` reuses the same non-financial operational fact already shown in
// this page's TRACTION strip (and Locations.tsx) — not a new claim.
// `gmvGrowth`/`customerGrowth` are left undefined: unlike TRACTION's static
// counts, a growth *trend* is a claim about real revenue/customer momentum
// that an investor reading this exact section could specifically rely on
// and later check — treated at the same tier as sustainabilityMetrics.ts's
// withheld carbon/eco-adoption stats, not the TRACTION tier. Each field
// renders independently in the stat strip, so a real figure can be added
// later without any component change.
export const GROWTH_METRICS: GrowthMetrics = {
  cities: "12",
};
